




















import { defineComponent, ref, watch } from '@vue/composition-api';
import { FitHalfScreenDialogV2, FitButton } from '@tencent/wphk-ui';
import { useHalfTask } from '@/hooks/use-half-task';
import TaskVue from './index.vue';

export default defineComponent({
  components: {
    FitHalfScreenDialogV2,
    FitButton,
    TaskVue,
  },
  setup() {
    const refHalfTask = ref<InstanceType<typeof FitHalfScreenDialogV2> | null>(null);

    const { isShowHalfTask, hideHalfTask } = useHalfTask();
    watch(isShowHalfTask, () => {
      if (isShowHalfTask.value) {
        refHalfTask.value?.showDialog();
      } else {
        refHalfTask.value?.hideDialog();
      }
    });

    return {
      refHalfTask,
      onClose: hideHalfTask,
    };
  },
});
